import { Component, Input } from '@angular/core';
import { HelpersService } from '../../../../../../services/helpers.service';
import { PartnerService } from '../../../../../../services/partner.service';
import moment from 'moment';

@Component({
  selector: 'app-edit-store-subscription',
  templateUrl: './edit-store-subscription.component.html',
  styleUrls: ['./edit-store-subscription.component.scss']
})
export class EditStoreSubscriptionComponent {

  @Input() partner;

  public loading : boolean = false;
  public partnerStatus : any = null;
  public workshopProductPlans : any = null;
  public rentalProductPlans : any = null;
  public whatsappProductPlans : any = null;
  public today : Date = new Date();
  public showWorkshopSubscription : boolean = false;
  public showRentalsSubscription : boolean = false;
  public showWhatsappSubscription : boolean = false;
  public savingChanges : boolean = false;
  public changesSaved : boolean = false;

  public statuses : any =[
    {value: 1, label: 'Trial'},
    {value: 2, label: 'Trial Expired'},
    {value: 21, label: 'Cancelled'},
    {value: 50, label: 'Active'},
    {value: 51, label: 'Demo Store'},
  ]

  public whatsappStatuses : any =[
    {value: 21, label: 'Cancelled'},
    {value: 50, label: 'Active'},
    {value: 51, label: 'Demo Store'},
  ]

  constructor(
    private partnerService: PartnerService,
    private helpersService: HelpersService
  ) {}

  ngOnInit() {
    console.log(this.partner);
    this.getPartnerSubscriptionDetails();
  }

  getPartnerSubscriptionDetails(){
    this.loading = true;
    this.partnerService.getPartnerSubscriptionInformation(this.partner.id).subscribe(partnerStatus => {
      console.log(partnerStatus);
      this.partnerStatus = partnerStatus;
      this.workshopProductPlans = partnerStatus.productPlans.filter(x=>{return x.productType === 'WORKSHOP'}).map(x=>{return {value: x.stripeProductID, label: x.plan}});
      this.rentalProductPlans = partnerStatus.productPlans.filter(x=>{return x.productType === 'RENTALS'}).map(x=>{return {value: x.stripeProductID, label: x.plan}});
      this.whatsappProductPlans = partnerStatus.productPlans.filter(x=>{return x.portalIdentifier === 'WHATSAPP'}).map(x=>{return {value: x.stripeProductID, label: x.plan}});

      if(this.partnerStatus.workShopPlan && this.partnerStatus.workShopPlan.trialEnds){
        this.partnerStatus.workShopPlan.trialEnds = moment.utc(this.partnerStatus.workShopPlan.trialEnds).toDate();
      }
      if(this.partnerStatus.rentalPlan && this.partnerStatus.rentalPlan.trialEnds){
        this.partnerStatus.rentalPlan.trialEnds = moment.utc(this.partnerStatus.rentalPlan.trialEnds).toDate();
      }
      if(this.partnerStatus.whatsappPlan && this.partnerStatus.whatsappPlan.trialEnds){
        this.partnerStatus.whatsappPlan.trialEnds = moment.utc(this.partnerStatus.whatsappPlan.trialEnds).toDate();
      }

      if(this.partnerStatus.workShopPlan === null || this.partnerStatus.workShopPlan === undefined){
        this.partnerStatus.workShopPlan = {};
      }else{
        this.showWorkshopSubscription = true;
      }
      
      if(this.partnerStatus.rentalPlan === null || this.partnerStatus.rentalPlan === undefined){
        this.partnerStatus.rentalPlan = {};
      }else{
        this.showRentalsSubscription = true;
      }

      if(this.partnerStatus.whatsappPlan === null || this.partnerStatus.whatsappPlan === undefined){
        this.partnerStatus.whatsappPlan = {};
      }else{
        this.showWhatsappSubscription = true;
      }

      this.loading = false;
    });
  }

  updateSubscription(){
    this.savingChanges = true;
    this.changesSaved = false;

    var data = {
      ...JSON.parse(JSON.stringify(this.partnerStatus))
    }
    if(data.rentalPlan.trialEnds){
      data.rentalPlan.trialEnds = moment(data.rentalPlan.trialEnds).format('YYYY-MM-DD');
    }
    if(data.workShopPlan.trialEnds){
      data.workShopPlan.trialEnds = moment(data.workShopPlan.trialEnds).format('YYYY-MM-DD');
    }

    this.partnerService.updatePartnerSubscriptionInformation(this.partner.id, this.partnerStatus).subscribe(res=>{
      console.log(res)
      this.savingChanges = false;
      this.changesSaved = true;
    },err=>{
      this.savingChanges = false;
      this.changesSaved = false;
    });
  }

  valid(){
    var valid = true;
    if(this.partnerStatus && this.partnerStatus.workShopPlan && this.partnerStatus.workShopPlan.stripeProductID && !this.partnerStatus.workShopPlan.statusID){
      valid = false;
    }
    if(this.partnerStatus && this.partnerStatus.workShopPlan && this.partnerStatus.workShopPlan.stripeProductID && this.partnerStatus.workShopPlan.statusID == 1 && !this.partnerStatus.workShopPlan.trialEnds){
      valid = false;
    }
    if(this.partnerStatus && this.partnerStatus.rentalPlan && this.partnerStatus.rentalPlan.stripeProductID && !this.partnerStatus.rentalPlan.statusID){
      valid = false;
    }
    if(this.partnerStatus && this.partnerStatus.rentalPlan && this.partnerStatus.rentalPlan.stripeProductID && this.partnerStatus.rentalPlan.statusID == 1 && !this.partnerStatus.rentalPlan.trialEnds){
      valid = false;
    }

    return valid;
  }

}
